import { Action, createReducer, on } from '@ngrx/store';
import { CommunicationsActions } from './communications.actions';
import { CategoryModel } from './communications.model';

export const STORE_FEATURE_KEY_COMMUNICATION = "communications";
export interface CommunicationsState {
    selectedCategory: CategoryModel,
    loading: boolean
}

export const initializeCommunicationState: CommunicationsState = {
    loading: false,
    selectedCategory: undefined
}

const reducer = createReducer(
    initializeCommunicationState,
    on(CommunicationsActions.selectedCategory, (state, { selectedCategory}) => ({
        ...state,
        selectedCategory,
        loading: true
    }))
);

export function CommunicationsReducers(
    state: CommunicationsState | undefined,
    action: Action
): CommunicationsState {
    return reducer(state, action);
}
